import React, { useState, useRef } from "react";
import {
    Container,
    Typography,
    TextField,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    MenuItem,
    Button,
    Grid,
    Paper,
    Divider,
    Box,
    Chip,
    Card,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    useTheme,
    useMediaQuery,
    Fade,
    Zoom,
    CircularProgress,
    Alert,
    Stack
} from "@mui/material";
// Removed import - using predefined subjects array instead
// import useSubjectsAndUnits from "../hooks/useSubjectsAndUnits";
//import axios from "axios";
import api from "../axios/axiosInstance";

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import PushPinIcon from '@mui/icons-material/PushPin';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import SchoolIcon from '@mui/icons-material/School';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PsychologyIcon from '@mui/icons-material/Psychology';
import TimelineIcon from '@mui/icons-material/Timeline';
import GradeIcon from '@mui/icons-material/Grade';
import PersonIcon from '@mui/icons-material/Person';
import DownloadIcon from '@mui/icons-material/Download';
import GenerateIcon from '@mui/icons-material/AutoFixHigh';
import ScienceIcon from '@mui/icons-material/Science';

import html2pdf from 'html2pdf.js';
import { Document, Packer, Paragraph, TextRun, HeadingLevel, AlignmentType, Table as DocxTable, TableRow as DocxTableRow, TableCell as DocxTableCell, WidthType } from "docx";
import { SpinningGradelyLoader, FloatingGradelyLoader } from '../loadingIcons/LoadingIcons';




import AIGenerationLimitDialog from '../dialogs/AIGenerationLimitDialog';
import handleAIError from '../utils/handleAIError';



//import downloadDataAsFile from '../hooks/downloadDataAsFile';

// Predefined arrays for dropdown options
const gradeLevels = ["KG", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
const subjects = [
    "Mathematics",
    "English Language Arts",
    "Science",
    "Social Studies",
    "Physical Education",
    "Art",
    "Music",
    "French",
    "Health Education",
    "Career Education"
];

const UnitPlanGenerator = ({ setActiveTabGlobal }) => {
    const [gradeLevel, setGradeLevel] = useState("");
    const [selectedSubject, setSelectedSubject] = useState("");
    //const [unitId, setUnitId] = useState("");
    const [topic, setTopic] = useState("");
    const [loading, setLoading] = useState(false);
    const [unitPlan, setUnitPlan] = useState(null);
    const [unitName, setUnitName] = useState("");

    // Removed useSubjectsAndUnits hook - using predefined subjects array instead
    const theme = useTheme();

    const [error, setError] = useState("");
    const unitPlanRef = useRef();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));



    //Dialogue Box for AI Limit
    const [showLimitDialog, setShowLimitDialog] = useState(false);
    const [alertDialog, setAlertDialog] = useState({ open: false, message: "" });


    const dokTitles = {
        DOK1: "Recall & Reproduction",
        DOK2: "Skills & Concepts",
        DOK3: "Strategic Thinking",
        DOK4: "Extended Thinking"
    };
    const handleSubmit = async () => {
        if (!gradeLevel || !selectedSubject || !unitName || !topic.trim()) {
            alert("Please complete all fields.");
            return;
        }

        setLoading(true);
        setUnitPlan(null);
        setError("");
        try {


            const res = await api.post(
                `${process.env.REACT_APP_BACKEND_URL}/grades/ai/unit-plan/`,
                {
                    grade_level: gradeLevel,
                    subject: selectedSubject,
                    unit: unitName,
                    topic: topic,
                },
                { withCredentials: true }
            );


            setUnitPlan({
                unit_overview: res.data.unit_plan?.unit_overview || {
                    title: "", grade_level: "", curricular_area: "", estimated_duration: ""
                },
                big_ideas_and_content: {
                    big_ideas: res.data.unit_plan?.big_ideas_and_content?.big_ideas || [],
                    core_content: res.data.unit_plan?.big_ideas_and_content?.core_content || [],
                },
                competencies: {
                    curricular_competencies: res.data.unit_plan?.competencies?.curricular_competencies || [],
                    core_competencies: res.data.unit_plan?.competencies?.core_competencies || [],
                },
                thematic_breakdown: res.data.unit_plan?.thematic_breakdown || [],
                summative_task: res.data.unit_plan?.summative_task || "",
                rubric: res.data.unit_plan?.rubric || [],
                student_self_assessment: {
                    checklist: res.data.unit_plan?.student_self_assessment?.checklist || [],
                    reflection_prompts: res.data.unit_plan?.student_self_assessment?.reflection_prompts || [],
                    self_rating_options: res.data.unit_plan?.student_self_assessment?.self_rating_options || [],
                }
            });
            if (!res.ok) {
                let data;
                try {
                    data = await res.json();
                } catch (jsonErr) {
                    // Response is not valid JSON
                    throw new Error("Failed to generate unit plan. Please try again.");
                }

                const error = new Error(data.detail || data.error || "Something went wrong.");
                error.response = {
                    status: res.status,
                    data,
                };
                throw error;
            }


        } catch (err) {

            handleAIError(err, { setErrorMsg: (msg) => setAlertDialog({ open: true, message: msg }), setShowLimitDialog });
        } finally {
            setLoading(false);
        }
    };

    const generatePDFHTML = (unitPlanData) => {
        // Theme colors for PDF
        const primaryColor = '#546A2F'; // Theme main color
        const secondaryColor = '#A8B87C'; // Theme secondary color
        const successColor = '#2e7d32'; // Material-UI success green
        const infoColor = '#0288d1'; // Material-UI info blue
        const warningColor = '#ed6c02'; // Material-UI warning orange
        const errorColor = '#d32f2f'; // Material-UI error red
        const greyColor = '#757575'; // Material-UI grey
        const lightGreyColor = '#f5f5f5'; // Light grey background
        const borderColor = '#e0e0e0'; // Light border color

        const html = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                <title>Unit Plan - ${selectedSubject || 'Subject'}</title>
            </head>
            <body style="font-family: 'Times New Roman', serif; margin: 0; padding: 0; line-height: 1.5; color: #212121; font-size: 11pt; background: white;">
                <div style="text-align: center; margin-bottom: 30px; border-bottom: 3px solid ${primaryColor}; padding-bottom: 15px;">
                    <div style="font-size: 20pt; font-weight: bold; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 1px; color: ${primaryColor};">Unit Plan</div>
                    <div style="font-size: 12pt; font-weight: bold; margin-bottom: 5px; color: ${secondaryColor};">${selectedSubject || 'Subject'} | Grade ${gradeLevel}</div>
                </div>

                <div style="background: ${lightGreyColor}; border: 2px solid ${primaryColor}; padding: 15px; margin-bottom: 25px; border-radius: 8px;">
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid ${borderColor};">
                            <span style="font-weight: bold; color: ${primaryColor}; font-size: 10pt; text-transform: uppercase;">Grade Level:</span>
                            <span style="font-weight: bold; color: ${successColor}; font-size: 10pt;">${unitPlanData.unit_overview.grade_level}</span>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid ${borderColor};">
                            <span style="font-weight: bold; color: ${primaryColor}; font-size: 10pt; text-transform: uppercase;">Subject Area:</span>
                            <span style="font-weight: bold; color: ${secondaryColor}; font-size: 10pt;">${unitPlanData.unit_overview.curricular_area}</span>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid ${borderColor};">
                            <span style="font-weight: bold; color: ${primaryColor}; font-size: 10pt; text-transform: uppercase;">Duration:</span>
                            <span style="font-weight: bold; color: ${warningColor}; font-size: 10pt;">${unitPlanData.unit_overview.estimated_duration}</span>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid ${borderColor};">
                            <span style="font-weight: bold; color: ${primaryColor}; font-size: 10pt; text-transform: uppercase;">Unit Title:</span>
                            <span style="font-weight: bold; color: #212121; font-size: 10pt;">${unitPlanData.unit_overview.title || 'N/A'}</span>
                        </div>
                    </div>
                </div>

                ${(() => {
                const sections = [];

                // Big Ideas and Content
                if (unitPlanData.big_ideas_and_content) {
                    sections.push(`
                            <div style="margin-bottom: 25px; page-break-inside: avoid;">
                                <div style="font-size: 14pt; font-weight: bold; color: ${primaryColor}; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Big Ideas and Content</div>
                                <div style="background: white; border: 2px solid ${borderColor}; padding: 15px; margin-bottom: 15px; border-radius: 8px;">
                                    <div style="margin-bottom: 15px;">
                                        <div style="font-weight: bold; color: ${secondaryColor}; margin-bottom: 6px; font-size: 10pt; text-transform: uppercase;">Big Ideas:</div>
                                        ${unitPlanData.big_ideas_and_content.big_ideas && Array.isArray(unitPlanData.big_ideas_and_content.big_ideas) ?
                            `<div>${unitPlanData.big_ideas_and_content.big_ideas.map((item, index) =>
                                `<div style="margin-bottom: 8px; padding-left: 25px; position: relative; text-align: justify; font-size: 10pt;">
                                                    <span style="position: absolute; left: 0; font-weight: bold; color: ${primaryColor}; font-size: 11pt;">${index + 1}. </span><span style="color: #212121;">${item}</span>
                                                </div>`
                            ).join('')}</div>` : ''
                        }
                                    </div>
                                    <div style="margin-bottom: 15px;">
                                        <div style="font-weight: bold; color: ${secondaryColor}; margin-bottom: 6px; font-size: 10pt; text-transform: uppercase;">Core Content:</div>
                                        ${unitPlanData.big_ideas_and_content.core_content && Array.isArray(unitPlanData.big_ideas_and_content.core_content) ?
                            `<div>${unitPlanData.big_ideas_and_content.core_content.map((item, index) =>
                                `<div style="margin-bottom: 8px; padding-left: 25px; position: relative; text-align: justify; font-size: 10pt;">
                                                    <span style="position: absolute; left: 0; font-weight: bold; color: ${primaryColor}; font-size: 11pt;">${index + 1}. </span><span style="color: #212121;">${item}</span>
                                                </div>`
                            ).join('')}</div>` : ''
                        }
                                    </div>
                                </div>
                            </div>
                        `);
                }

                // Competencies
                if (unitPlanData.competencies) {
                    sections.push(`
                            <div style="margin-bottom: 25px; page-break-inside: avoid;">
                                <div style="font-size: 14pt; font-weight: bold; color: ${primaryColor}; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Competencies</div>
                                <div style="background: white; border: 2px solid ${borderColor}; padding: 15px; margin-bottom: 15px; border-radius: 8px;">
                                    <div style="margin-bottom: 15px;">
                                        <div style="font-weight: bold; color: ${secondaryColor}; margin-bottom: 6px; font-size: 10pt; text-transform: uppercase;">Curricular Competencies:</div>
                                        ${unitPlanData.competencies.curricular_competencies && Array.isArray(unitPlanData.competencies.curricular_competencies) ?
                            `<div>${unitPlanData.competencies.curricular_competencies.map((item, index) =>
                                `<div style="margin-bottom: 8px; padding-left: 25px; position: relative; text-align: justify; font-size: 10pt;">
                                                    <span style="position: absolute; left: 0; font-weight: bold; color: ${primaryColor}; font-size: 11pt;">${index + 1}. </span><span style="color: #212121;">${item}</span>
                                                </div>`
                            ).join('')}</div>` : ''
                        }
                                    </div>
                                    <div style="margin-bottom: 15px;">
                                        <div style="font-weight: bold; color: ${secondaryColor}; margin-bottom: 6px; font-size: 10pt; text-transform: uppercase;">Core Competencies:</div>
                                        ${unitPlanData.competencies.core_competencies && Array.isArray(unitPlanData.competencies.core_competencies) ?
                            `<div>${unitPlanData.competencies.core_competencies.map((item, index) =>
                                `<div style="margin-bottom: 8px; padding-left: 25px; position: relative; text-align: justify; font-size: 10pt;">
                                                    <span style="position: absolute; left: 0; font-weight: bold; color: ${primaryColor}; font-size: 11pt;">${index + 1}. </span><span style="color: #212121;">${item}</span>
                                                </div>`
                            ).join('')}</div>` : ''
                        }
                                    </div>
                                </div>
                            </div>
                        `);
                }

                // Thematic Breakdown
                if (unitPlanData.thematic_breakdown && Array.isArray(unitPlanData.thematic_breakdown)) {
                    sections.push(`
                            <div style="margin-bottom: 25px; page-break-inside: avoid;">
                                <div style="font-size: 14pt; font-weight: bold; color: ${primaryColor}; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Thematic Breakdown</div>
                                <div style="background: white; border: 2px solid ${borderColor}; padding: 15px; margin-bottom: 15px; border-radius: 8px;">
                                    ${unitPlanData.thematic_breakdown.map((week, index) => `
                                        <div style="margin-bottom: 20px; padding-bottom: 15px; border-bottom: ${index < unitPlanData.thematic_breakdown.length - 1 ? `1px solid ${borderColor}` : 'none'};">
                                            <div style="font-size: 12pt; font-weight: bold; color: ${secondaryColor}; margin-bottom: 8px; text-transform: uppercase;">
                                                ${week.title || `Week ${index + 1}`}
                                            </div>
                                            
                                            ${week.learning_goals && Array.isArray(week.learning_goals) ? `
                                                <div style="margin-bottom: 10px;">
                                                    <div style="font-weight: bold; color: ${primaryColor}; margin-bottom: 4px; font-size: 9pt; text-transform: uppercase;">Learning Goals:</div>
                                                    <div style="padding-left: 15px;">
                                                        ${week.learning_goals.map((goal, gIndex) =>
                        `<div style="margin-bottom: 4px; padding-left: 20px; position: relative; text-align: justify; font-size: 9pt;">
                                                                <span style="position: absolute; left: 0; font-weight: bold; color: ${primaryColor}; font-size: 9pt;">• </span><span style="color: #212121;">${goal}</span>
                                                            </div>`
                    ).join('')}
                                                    </div>
                                                </div>
                                            ` : ''}
                                            
                                            ${week.activities && Array.isArray(week.activities) ? `
                                                <div style="margin-bottom: 10px;">
                                                    <div style="font-weight: bold; color: ${primaryColor}; margin-bottom: 4px; font-size: 9pt; text-transform: uppercase;">Activities:</div>
                                                    <div style="padding-left: 15px;">
                                                        ${week.activities.map((activity, aIndex) =>
                        `<div style="margin-bottom: 4px; padding-left: 20px; position: relative; text-align: justify; font-size: 9pt;">
                                                                <span style="position: absolute; left: 0; font-weight: bold; color: ${primaryColor}; font-size: 9pt;">• </span><span style="color: #212121;">${activity}</span>
                                                            </div>`
                    ).join('')}
                                                    </div>
                                                </div>
                                            ` : ''}
                                        </div>
                                    `).join('')}
                                </div>
                            </div>
                        `);
                }

                // Summative Task
                if (unitPlanData.summative_task) {
                    sections.push(`
                            <div style="margin-bottom: 25px; page-break-inside: avoid;">
                                <div style="font-size: 14pt; font-weight: bold; color: ${primaryColor}; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Summative Task</div>
                                <div style="background: white; border: 2px solid ${borderColor}; padding: 15px; margin-bottom: 15px; border-radius: 8px;">
                                    <div style="font-size: 10pt; line-height: 1.4; text-align: justify; margin-bottom: 10px; color: #212121;">${unitPlanData.summative_task}</div>
                                </div>
                            </div>
                        `);
                }

                // Rubric
                if (unitPlanData.rubric && Array.isArray(unitPlanData.rubric)) {
                    sections.push(`
                            <div style="margin-bottom: 25px; page-break-inside: avoid;">
                                <div style="font-size: 14pt; font-weight: bold; color: ${primaryColor}; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Rubric</div>
                                <div style="background: white; border: 2px solid ${borderColor}; padding: 15px; margin-bottom: 15px; border-radius: 8px;">
                                    ${unitPlanData.rubric.map((rubricItem, index) => `
                                        <div style="margin-bottom: 15px; padding-bottom: 10px; border-bottom: ${index < unitPlanData.rubric.length - 1 ? `1px solid ${borderColor}` : 'none'};">
                                            <div style="font-weight: bold; color: ${secondaryColor}; margin-bottom: 6px; font-size: 10pt; text-transform: uppercase;">${rubricItem.skill_area || `Skill Area ${index + 1}`}:</div>
                                            <div style="padding-left: 10px;">
                                                ${rubricItem.emerging ? `<div style="margin-bottom: 3px; font-size: 9pt;"><strong style="color: ${errorColor};">Emerging:</strong> <span style="color: #212121;">${rubricItem.emerging}</span></div>` : ''}
                                                ${rubricItem.developing ? `<div style="margin-bottom: 3px; font-size: 9pt;"><strong style="color: ${warningColor};">Developing:</strong> <span style="color: #212121;">${rubricItem.developing}</span></div>` : ''}
                                                ${rubricItem.proficient ? `<div style="margin-bottom: 3px; font-size: 9pt;"><strong style="color: ${successColor};">Proficient:</strong> <span style="color: #212121;">${rubricItem.proficient}</span></div>` : ''}
                                                ${rubricItem.extending ? `<div style="margin-bottom: 3px; font-size: 9pt;"><strong style="color: ${infoColor};">Extending:</strong> <span style="color: #212121;">${rubricItem.extending}</span></div>` : ''}
                                            </div>
                                        </div>
                                    `).join('')}
                                </div>
                            </div>
                        `);
                }

                // Student Self Assessment
                if (unitPlanData.student_self_assessment) {
                    sections.push(`
                            <div style="margin-bottom: 25px; page-break-inside: avoid;">
                                <div style="font-size: 14pt; font-weight: bold; color: ${primaryColor}; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Student Self Assessment</div>
                                <div style="background: white; border: 2px solid ${borderColor}; padding: 15px; margin-bottom: 15px; border-radius: 8px;">
                                    ${unitPlanData.student_self_assessment.checklist && Array.isArray(unitPlanData.student_self_assessment.checklist) ? `
                                        <div style="margin-bottom: 15px;">
                                            <div style="font-weight: bold; color: ${secondaryColor}; margin-bottom: 6px; font-size: 10pt; text-transform: uppercase;">Checklist:</div>
                                            <div>${unitPlanData.student_self_assessment.checklist.map((item, index) =>
                        `<div style="margin-bottom: 6px; padding-left: 25px; position: relative; text-align: justify; font-size: 10pt;">
                                                    <span style="position: absolute; left: 0; font-weight: bold; color: ${primaryColor}; font-size: 11pt;">${index + 1}. </span><span style="color: #212121;">${item}</span>
                                                </div>`
                    ).join('')}</div>
                                        </div>
                                    ` : ''}
                                    
                                    ${unitPlanData.student_self_assessment.reflection_prompts && Array.isArray(unitPlanData.student_self_assessment.reflection_prompts) ? `
                                        <div style="margin-bottom: 15px;">
                                            <div style="font-weight: bold; color: ${secondaryColor}; margin-bottom: 6px; font-size: 10pt; text-transform: uppercase;">Reflection Prompts:</div>
                                            <div>${unitPlanData.student_self_assessment.reflection_prompts.map((item, index) =>
                        `<div style="margin-bottom: 6px; padding-left: 25px; position: relative; text-align: justify; font-size: 10pt;">
                                                    <span style="position: absolute; left: 0; font-weight: bold; color: ${primaryColor}; font-size: 11pt;">${index + 1}. </span><span style="color: #212121;">${item}</span>
                                                </div>`
                    ).join('')}</div>
                                        </div>
                                    ` : ''}
                                </div>
                            </div>
                        `);
                }

                return sections.join('');
            })()}
            </body>
            </html>
        `;
        return html;
    };

    const handleDownloadPDF = () => {
        if (!unitPlan) return;

        // Get your HTML string
        const pdfHTML = generatePDFHTML(unitPlan);

        const opt = {
            margin: [0.5, 0.5, 0.5, 0.5],
            filename: `Unit Plan - ${unitPlan.unit_overview.title || 'Unit Plan'}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                scrollX: 0,
                scrollY: 0
            },
            jsPDF: {
                unit: 'in',
                format: 'a4',
                orientation: 'portrait',
                compress: true
            },
            pagebreak: { mode: 'avoid-all' }
        };

        // Create a temporary container element
        const container = document.createElement('div');

        // 🔹 Inject all current <style> and <link rel="stylesheet"> tags so MUI styles carry over
        const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
            .map(node => node.outerHTML)
            .join('\n');

        container.innerHTML = `
        <html>
            <head>
                ${styles}
            </head>
            <body>
                ${pdfHTML}
            </body>
        </html>
    `;

        // Now feed that fully styled DOM to html2pdf
        html2pdf().set(opt).from(container).save();
    };

    const generateWordDocument = async (unitPlanData) => {
        // Theme colors for Word document (matching PDF colors)
        const primaryColor = '546A2F'; // Theme main color
        const secondaryColor = 'A8B87C'; // Theme secondary color
        const successColor = '2e7d32'; // Material-UI success green
        const infoColor = '0288d1'; // Material-UI info blue
        const warningColor = 'ed6c02'; // Material-UI warning orange
        const errorColor = 'd32f2f'; // Material-UI error red

        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children: [
                        // Title
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "UNIT PLAN",
                                    bold: true,
                                    size: 40,
                                    color: primaryColor
                                })
                            ],
                            heading: HeadingLevel.TITLE,
                            alignment: AlignmentType.CENTER,
                            spacing: { after: 300 }
                        }),

                        // Subject and Grade Information
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `${selectedSubject || 'Subject'} | Grade ${gradeLevel}`,
                                    bold: true,
                                    size: 24,
                                    color: secondaryColor
                                })
                            ],
                            alignment: AlignmentType.CENTER,
                            spacing: { after: 400 }
                        }),

                        // Unit Overview Section
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "UNIT OVERVIEW",
                                    bold: true,
                                    size: 28,
                                    color: primaryColor
                                })
                            ],
                            heading: HeadingLevel.HEADING_1,
                            spacing: { before: 300, after: 200 }
                        }),

                        // Grade Level
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Grade Level: ",
                                    bold: true,
                                    size: 22,
                                    color: primaryColor
                                }),
                                new TextRun({
                                    text: unitPlanData.unit_overview.grade_level,
                                    size: 22,
                                    color: successColor
                                })
                            ],
                            spacing: { after: 100 }
                        }),

                        // Subject Area
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Subject Area: ",
                                    bold: true,
                                    size: 22,
                                    color: primaryColor
                                }),
                                new TextRun({
                                    text: unitPlanData.unit_overview.curricular_area,
                                    size: 22,
                                    color: secondaryColor
                                })
                            ],
                            spacing: { after: 100 }
                        }),

                        // Duration
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Duration: ",
                                    bold: true,
                                    size: 22,
                                    color: primaryColor
                                }),
                                new TextRun({
                                    text: unitPlanData.unit_overview.estimated_duration,
                                    size: 22,
                                    color: warningColor
                                })
                            ],
                            spacing: { after: 100 }
                        }),

                        // Unit Title
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Unit Title: ",
                                    bold: true,
                                    size: 22,
                                    color: primaryColor
                                }),
                                new TextRun({
                                    text: unitPlanData.unit_overview.title || 'N/A',
                                    size: 22
                                })
                            ],
                            spacing: { after: 400 }
                        }),

                        // Big Ideas and Content Section
                        ...(unitPlanData.big_ideas_and_content ? [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "BIG IDEAS AND CONTENT",
                                        bold: true,
                                        size: 28,
                                        color: primaryColor
                                    })
                                ],
                                heading: HeadingLevel.HEADING_1,
                                spacing: { before: 300, after: 200 }
                            }),

                            // Big Ideas
                            ...(unitPlanData.big_ideas_and_content.big_ideas && Array.isArray(unitPlanData.big_ideas_and_content.big_ideas) ? [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Big Ideas:",
                                            bold: true,
                                            size: 24,
                                            color: secondaryColor
                                        })
                                    ],
                                    spacing: { before: 200, after: 100 }
                                }),
                                ...unitPlanData.big_ideas_and_content.big_ideas.map((item, index) =>
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: `${index + 1}. `,
                                                bold: true,
                                                size: 22,
                                                color: primaryColor
                                            }),
                                            new TextRun({
                                                text: item,
                                                size: 22
                                            })
                                        ],
                                        spacing: { after: 100 }
                                    })
                                )
                            ] : []),

                            // Core Content
                            ...(unitPlanData.big_ideas_and_content.core_content && Array.isArray(unitPlanData.big_ideas_and_content.core_content) ? [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Core Content:",
                                            bold: true,
                                            size: 24,
                                            color: secondaryColor
                                        })
                                    ],
                                    spacing: { before: 200, after: 100 }
                                }),
                                ...unitPlanData.big_ideas_and_content.core_content.map((item, index) =>
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: `${index + 1}. `,
                                                bold: true,
                                                size: 22,
                                                color: primaryColor
                                            }),
                                            new TextRun({
                                                text: item,
                                                size: 22
                                            })
                                        ],
                                        spacing: { after: 100 }
                                    })
                                )
                            ] : [])
                        ] : []),

                        // Competencies Section
                        ...(unitPlanData.competencies ? [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "COMPETENCIES",
                                        bold: true,
                                        size: 28,
                                        color: primaryColor
                                    })
                                ],
                                heading: HeadingLevel.HEADING_1,
                                spacing: { before: 300, after: 200 }
                            }),

                            // Curricular Competencies
                            ...(unitPlanData.competencies.curricular_competencies && Array.isArray(unitPlanData.competencies.curricular_competencies) ? [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Curricular Competencies:",
                                            bold: true,
                                            size: 24,
                                            color: secondaryColor
                                        })
                                    ],
                                    spacing: { before: 200, after: 100 }
                                }),
                                ...unitPlanData.competencies.curricular_competencies.map((item, index) =>
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: `${index + 1}. `,
                                                bold: true,
                                                size: 22,
                                                color: primaryColor
                                            }),
                                            new TextRun({
                                                text: item,
                                                size: 22
                                            })
                                        ],
                                        spacing: { after: 100 }
                                    })
                                )
                            ] : []),

                            // Core Competencies
                            ...(unitPlanData.competencies.core_competencies && Array.isArray(unitPlanData.competencies.core_competencies) ? [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Core Competencies:",
                                            bold: true,
                                            size: 24,
                                            color: secondaryColor
                                        })
                                    ],
                                    spacing: { before: 200, after: 100 }
                                }),
                                ...unitPlanData.competencies.core_competencies.map((item, index) =>
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: `${index + 1}. `,
                                                bold: true,
                                                size: 22,
                                                color: primaryColor
                                            }),
                                            new TextRun({
                                                text: item,
                                                size: 22
                                            })
                                        ],
                                        spacing: { after: 100 }
                                    })
                                )
                            ] : [])
                        ] : []),

                        // Thematic Breakdown Section
                        ...(unitPlanData.thematic_breakdown && Array.isArray(unitPlanData.thematic_breakdown) ? [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "THEMATIC BREAKDOWN",
                                        bold: true,
                                        size: 28,
                                        color: primaryColor
                                    })
                                ],
                                heading: HeadingLevel.HEADING_1,
                                spacing: { before: 300, after: 200 }
                            }),
                            ...unitPlanData.thematic_breakdown.flatMap((week, index) => [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: week.title || `Week ${index + 1}`,
                                            bold: true,
                                            size: 24,
                                            color: secondaryColor
                                        })
                                    ],
                                    spacing: { before: 200, after: 100 }
                                }),

                                // Learning Goals
                                ...(week.learning_goals && Array.isArray(week.learning_goals) ? [
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: "Learning Goals:",
                                                bold: true,
                                                size: 20,
                                                color: primaryColor
                                            })
                                        ],
                                        spacing: { before: 100, after: 50 }
                                    }),
                                    ...week.learning_goals.map(goal =>
                                        new Paragraph({
                                            children: [
                                                new TextRun({
                                                    text: "• ",
                                                    bold: true,
                                                    size: 20,
                                                    color: primaryColor
                                                }),
                                                new TextRun({
                                                    text: goal,
                                                    size: 20
                                                })
                                            ],
                                            spacing: { after: 50 }
                                        })
                                    )
                                ] : []),

                                // Activities
                                ...(week.activities && Array.isArray(week.activities) ? [
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: "Activities:",
                                                bold: true,
                                                size: 20,
                                                color: primaryColor
                                            })
                                        ],
                                        spacing: { before: 100, after: 50 }
                                    }),
                                    ...week.activities.map(activity =>
                                        new Paragraph({
                                            children: [
                                                new TextRun({
                                                    text: "• ",
                                                    bold: true,
                                                    size: 20,
                                                    color: primaryColor
                                                }),
                                                new TextRun({
                                                    text: activity,
                                                    size: 20
                                                })
                                            ],
                                            spacing: { after: 50 }
                                        })
                                    )
                                ] : [])
                            ])
                        ] : []),

                        // Summative Task Section
                        ...(unitPlanData.summative_task ? [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "SUMMATIVE TASK",
                                        bold: true,
                                        size: 28,
                                        color: primaryColor
                                    })
                                ],
                                heading: HeadingLevel.HEADING_1,
                                spacing: { before: 300, after: 200 }
                            }),
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: unitPlanData.summative_task,
                                        size: 22
                                    })
                                ],
                                spacing: { after: 300 }
                            })
                        ] : []),

                        // Rubric Section
                        ...(unitPlanData.rubric && Array.isArray(unitPlanData.rubric) ? [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "ASSESSMENT RUBRIC",
                                        bold: true,
                                        size: 28,
                                        color: primaryColor
                                    })
                                ],
                                heading: HeadingLevel.HEADING_1,
                                spacing: { before: 300, after: 200 }
                            }),
                            new DocxTable({
                                width: {
                                    size: 100,
                                    type: WidthType.PERCENTAGE,
                                },
                                rows: [
                                    // Header row
                                    new DocxTableRow({
                                        children: [
                                            new DocxTableCell({
                                                children: [new Paragraph({
                                                    children: [new TextRun({ text: "Skill Area", bold: true, size: 20 })]
                                                })],
                                                width: { size: 20, type: WidthType.PERCENTAGE }
                                            }),
                                            new DocxTableCell({
                                                children: [new Paragraph({
                                                    children: [new TextRun({ text: "Emerging", bold: true, size: 20, color: errorColor })]
                                                })],
                                                width: { size: 20, type: WidthType.PERCENTAGE }
                                            }),
                                            new DocxTableCell({
                                                children: [new Paragraph({
                                                    children: [new TextRun({ text: "Developing", bold: true, size: 20, color: warningColor })]
                                                })],
                                                width: { size: 20, type: WidthType.PERCENTAGE }
                                            }),
                                            new DocxTableCell({
                                                children: [new Paragraph({
                                                    children: [new TextRun({ text: "Proficient", bold: true, size: 20, color: successColor })]
                                                })],
                                                width: { size: 20, type: WidthType.PERCENTAGE }
                                            }),
                                            new DocxTableCell({
                                                children: [new Paragraph({
                                                    children: [new TextRun({ text: "Extending", bold: true, size: 20, color: infoColor })]
                                                })],
                                                width: { size: 20, type: WidthType.PERCENTAGE }
                                            })
                                        ]
                                    }),
                                    // Data rows
                                    ...unitPlanData.rubric.map(rubricItem =>
                                        new DocxTableRow({
                                            children: [
                                                new DocxTableCell({
                                                    children: [new Paragraph({
                                                        children: [new TextRun({ text: rubricItem.skill_area || 'N/A', size: 18 })]
                                                    })]
                                                }),
                                                new DocxTableCell({
                                                    children: [new Paragraph({
                                                        children: [new TextRun({ text: rubricItem.emerging || 'N/A', size: 18 })]
                                                    })]
                                                }),
                                                new DocxTableCell({
                                                    children: [new Paragraph({
                                                        children: [new TextRun({ text: rubricItem.developing || 'N/A', size: 18 })]
                                                    })]
                                                }),
                                                new DocxTableCell({
                                                    children: [new Paragraph({
                                                        children: [new TextRun({ text: rubricItem.proficient || 'N/A', size: 18 })]
                                                    })]
                                                }),
                                                new DocxTableCell({
                                                    children: [new Paragraph({
                                                        children: [new TextRun({ text: rubricItem.extending || 'N/A', size: 18 })]
                                                    })]
                                                })
                                            ]
                                        })
                                    )
                                ]
                            })
                        ] : []),

                        // Student Self Assessment Section
                        ...(unitPlanData.student_self_assessment ? [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "STUDENT SELF ASSESSMENT",
                                        bold: true,
                                        size: 28,
                                        color: primaryColor
                                    })
                                ],
                                heading: HeadingLevel.HEADING_1,
                                spacing: { before: 300, after: 200 }
                            }),

                            // Checklist
                            ...(unitPlanData.student_self_assessment.checklist && Array.isArray(unitPlanData.student_self_assessment.checklist) ? [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Checklist:",
                                            bold: true,
                                            size: 24,
                                            color: secondaryColor
                                        })
                                    ],
                                    spacing: { before: 200, after: 100 }
                                }),
                                ...unitPlanData.student_self_assessment.checklist.map((item, index) =>
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: `${index + 1}. `,
                                                bold: true,
                                                size: 22,
                                                color: primaryColor
                                            }),
                                            new TextRun({
                                                text: item,
                                                size: 22
                                            })
                                        ],
                                        spacing: { after: 100 }
                                    })
                                )
                            ] : []),

                            // Reflection Prompts
                            ...(unitPlanData.student_self_assessment.reflection_prompts && Array.isArray(unitPlanData.student_self_assessment.reflection_prompts) ? [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Reflection Prompts:",
                                            bold: true,
                                            size: 24,
                                            color: secondaryColor
                                        })
                                    ],
                                    spacing: { before: 200, after: 100 }
                                }),
                                ...unitPlanData.student_self_assessment.reflection_prompts.map((item, index) =>
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: `${index + 1}. `,
                                                bold: true,
                                                size: 22,
                                                color: primaryColor
                                            }),
                                            new TextRun({
                                                text: item,
                                                size: 22,
                                                italics: true
                                            })
                                        ],
                                        spacing: { after: 100 }
                                    })
                                )
                            ] : []),

                            // Self-Rating Options
                            ...(unitPlanData.student_self_assessment.self_rating_options && Array.isArray(unitPlanData.student_self_assessment.self_rating_options) ? [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Self-Rating Options: ",
                                            bold: true,
                                            size: 24,
                                            color: secondaryColor
                                        }),
                                        new TextRun({
                                            text: unitPlanData.student_self_assessment.self_rating_options.join(', '),
                                            size: 22
                                        })
                                    ],
                                    spacing: { before: 200, after: 100 }
                                })
                            ] : [])
                        ] : []),

                        // Footer
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Generated by Gradely Educational Platform",
                                    size: 18,
                                    italics: true,
                                    color: "757575"
                                })
                            ],
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 600 }
                        })
                    ]
                }
            ]
        });

        return doc;
    };

    const downloadWordDocument = async (unitPlanData) => {
        try {
            const doc = await generateWordDocument(unitPlanData);
            const blob = await Packer.toBlob(doc);

            const element = document.createElement('a');
            element.href = URL.createObjectURL(blob);
            element.download = `${unitPlanData.unit_overview.title || 'Unit Plan'}_unit_plan.docx`;
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            URL.revokeObjectURL(element.href);
        } catch (error) {
            console.error('Error generating Word document:', error);
            alert('Error generating Word document. Please try again.');
        }
    };

    const iconMap = {
        "Big Ideas": <PushPinIcon color="primary" />,
        "Core Content": <MenuBookIcon color="secondary" />,
        "Curricular Competencies": <TrackChangesIcon sx={{ color: "#e57373" }} />,
        "Core Competencies": <EmojiObjectsIcon sx={{ color: "#fbc02d" }} />
    };

    const renderStyledArray = (title, items) => (
        <Zoom in timeout={600}>
            <Paper
                elevation={2}
                sx={{
                    p: { xs: 2, sm: 3 },
                    mb: 3,
                    borderLeft: `6px solid ${theme.palette.primary.main}`,
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: { xs: 1, sm: 1.5, md: 2 },
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        boxShadow: 4,
                        transform: 'translateX(4px)'
                    }
                }}
            >
                <Box display="flex" alignItems="center" mb={2}>
                    {iconMap[title.replace("📌 ", "").replace("📚 ", "").replace("🎯 ", "").replace("💡 ", "")]}
                    <Typography
                        variant={isSmallMobile ? "h6" : "h5"}
                        fontWeight="bold"
                        sx={{ ml: 1 }}
                    >
                        {title}
                    </Typography>
                </Box>
                <List dense disablePadding>
                    {items.map((item, index) => (
                        <ListItem key={index} sx={{ pl: 0, mb: 1 }}>
                            <ListItemIcon sx={{ minWidth: 32 }}>
                                <CheckCircleOutlineIcon
                                    color="success"
                                    fontSize="small"
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            lineHeight: 1.6,
                                            fontSize: isSmallMobile ? '0.875rem' : '1rem'
                                        }}
                                    >
                                        {item}
                                    </Typography>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </Paper>
        </Zoom>
    );

    return (
        <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 3 } }}>
            <Fade in timeout={800}>
                <Paper
                    elevation={3}
                    sx={{
                        pt: 1,
                        px: { xs: 2, sm: 3, md: 4 },
                        pb: { xs: 2, sm: 3, md: 4 },
                        borderRadius: { xs: 1.5, sm: 2, md: 3 },
                        backgroundColor: theme.palette.background.paper,
                        background: theme.palette.background.paper
                    }}
                >
                    <Box sx={{ textAlign: 'center', mb: 2, mt: 0 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, mb: 0.5 }}>
                            <AssignmentIcon sx={{ fontSize: '2rem', color: theme.palette.primary.main }} />
                            <Typography
                                sx={{
                                    color: theme.palette.primary.main,
                                    fontWeight: 600,
                                    fontSize: '2rem'
                                }}
                            >
                                Generate Unit Plan
                            </Typography>
                        </Box>
                        <Typography
                            sx={{
                                color: theme.palette.primary.main,
                                fontStyle: 'italic',
                                fontSize: '1rem',
                                fontWeight: 400
                            }}
                        >
                            (BC curriculum aligned)
                        </Typography>
                    </Box>

                    {error && (
                        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError("")}>
                            {error}
                        </Alert>
                    )}

                    <Grid container spacing={3} sx={{ mb: 4 }}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                select
                                label="Grade Level"
                                fullWidth
                                value={gradeLevel}
                                onChange={(e) => setGradeLevel(e.target.value)}
                                InputProps={{
                                    startAdornment: <GradeIcon sx={{ mr: 1, color: 'action.active' }} />
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: { xs: 1, sm: 1.5, md: 2 }
                                    }
                                }}
                            >
                                {gradeLevels.map((level) => (
                                    <MenuItem key={level} value={level}>
                                        {`Grade ${level}`}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Subject"
                                fullWidth
                                value={selectedSubject}
                                onChange={(e) => setSelectedSubject(e.target.value)}
                                placeholder="Enter subject name"
                                InputProps={{
                                    startAdornment: <SchoolIcon sx={{ mr: 1, color: 'action.active' }} />
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: { xs: 1, sm: 1.5, md: 2 }
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Unit Name"
                                placeholder="e.g. Forces and Friction"
                                value={unitName}
                                onChange={(e) => setUnitName(e.target.value)}
                                fullWidth
                                InputProps={{
                                    startAdornment: <MenuBookIcon sx={{ mr: 1, color: 'action.active' }} />
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: { xs: 1, sm: 1.5, md: 2 }
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Topic and Instructional Focus"
                                value={topic}
                                onChange={(e) => setTopic(e.target.value)}
                                multiline
                                minRows={3}
                                fullWidth
                                InputProps={{
                                    startAdornment: <EmojiObjectsIcon sx={{ mr: 1, color: 'action.active', mt: 1 }} />
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: { xs: 1, sm: 1.5, md: 2 }
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={handleSubmit}
                                disabled={loading}
                                sx={{
                                    py: 1.5,
                                    borderRadius: { xs: 1, sm: 1.5, md: 2 },
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                    backgroundColor: theme.palette.primary.main,
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.dark,
                                        transform: 'translateY(-2px)',
                                        boxShadow: 4
                                    }
                                }}
                            >
                                {loading ? (
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <CircularProgress size={20} color="inherit" />
                                        <span>Generating...</span>
                                    </Stack>
                                ) : (
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <GenerateIcon />
                                        <span>Generate Unit Plan</span>
                                    </Stack>
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Fade>

            {unitPlan && (
                <Fade in timeout={600}>
                    <Box sx={{ mt: 4 }}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            mb: 3,
                            flexDirection: isSmallMobile ? 'column' : 'row',
                            gap: 2
                        }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleDownloadPDF}
                                sx={{
                                    borderRadius: 2,
                                    backgroundColor: theme.palette.primary.main,
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.dark,
                                        transform: 'translateY(-2px)',
                                        boxShadow: 4
                                    }
                                }}
                            >
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <DownloadIcon />
                                    <span>Download PDF</span>
                                </Stack>
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => downloadWordDocument(unitPlan)}
                                sx={{
                                    borderRadius: 2,
                                    backgroundColor: theme.palette.primary.main,
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.dark,
                                        transform: 'translateY(-2px)',
                                        boxShadow: 4
                                    }
                                }}
                            >
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <DownloadIcon />
                                    <span>Download Word</span>
                                </Stack>
                            </Button>
                        </Box>

                        <Paper
                            ref={unitPlanRef}
                            elevation={2}
                            sx={{
                                p: { xs: 2, sm: 3, md: 4 },
                                borderRadius: 4,
                                backgroundColor: theme.palette.background.default,
                                background: theme.palette.background.default,
                                '@media print': {
                                    borderRadius: 0,
                                    boxShadow: 'none',
                                    margin: 0,
                                    padding: '20px',
                                    pageBreakInside: 'avoid',
                                    breakInside: 'avoid'
                                }
                            }}
                        >
                            <Box sx={{ mb: 5 }}>
                                {/* Title */}
                                <Typography
                                    variant={isSmallMobile ? "h5" : isMobile ? "h4" : "h3"}
                                    fontWeight="bold"
                                    color="secondary.dark"
                                    gutterBottom
                                    sx={{
                                        textAlign: 'center',
                                        mb: 3,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 2
                                    }}
                                >
                                    <MenuBookIcon sx={{ fontSize: 'inherit' }} />
                                    {unitPlan.unit_overview.title}
                                </Typography>

                                {/* Overview Block */}
                                <Paper
                                    elevation={1}
                                    sx={{
                                        p: { xs: 2, sm: 3 },
                                        borderRadius: 3,
                                        backgroundColor: theme.palette.background.paper,
                                        mb: 4,
                                        border: `1px solid ${theme.palette.divider}`
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontSize: isSmallMobile ? '0.875rem' : '1rem',
                                            lineHeight: 1.8,
                                            textAlign: { xs: 'left', md: 'center' },
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: { xs: 'start', md: 'center' },
                                            gap: 2,
                                            flexWrap: 'wrap'
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <GradeIcon fontSize="small" color="primary" />
                                            <strong>Grade:</strong> {unitPlan.unit_overview.grade_level}
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <SchoolIcon fontSize="small" color="primary" />
                                            <strong>Subject:</strong> {unitPlan.unit_overview.curricular_area}
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <TimelineIcon fontSize="small" color="primary" />
                                            <strong>Duration:</strong> {unitPlan.unit_overview.estimated_duration}
                                        </Box>
                                    </Typography>
                                </Paper>

                                {/* Divider */}
                                <Divider
                                    sx={{
                                        my: 4,
                                        height: 4,
                                        borderRadius: 2,
                                        background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                    }}
                                />

                                {/* Core Curriculum Sections */}
                                {renderStyledArray("Big Ideas", unitPlan.big_ideas_and_content.big_ideas)}
                                {renderStyledArray("Core Content", unitPlan.big_ideas_and_content.core_content)}
                                {renderStyledArray("Curricular Competencies", unitPlan.competencies.curricular_competencies)}
                                {renderStyledArray("Core Competencies", unitPlan.competencies.core_competencies)}
                            </Box>

                            {/* Divider */}
                            <Divider
                                sx={{
                                    my: 4,
                                    height: 4,
                                    borderRadius: 2,
                                    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                }}
                            />

                            <Typography
                                variant={isSmallMobile ? "h6" : "h5"}
                                fontWeight="bold"
                                color="primary"
                                gutterBottom
                                sx={{
                                    textAlign: 'center',
                                    mb: 3,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 2
                                }}
                            >
                                <TimelineIcon sx={{ fontSize: 'inherit' }} />
                                Thematic Breakdown
                            </Typography>

                            {unitPlan.thematic_breakdown.map((section, idx) => (
                                <Zoom in timeout={600 + idx * 100} key={idx}>
                                    <Card sx={{
                                        mb: 4,
                                        p: { xs: 2, sm: 3 },
                                        borderRadius: 3,
                                        border: `1px solid ${theme.palette.divider}`,
                                        '&:hover': {
                                            boxShadow: 4
                                        }
                                    }}>
                                        <Typography
                                            variant={isSmallMobile ? "h6" : "h5"}
                                            fontWeight="bold"
                                            color="secondary.dark"
                                            gutterBottom
                                            sx={{ textAlign: 'center', mb: 3 }}
                                        >
                                            {section.title}
                                        </Typography>

                                        {/* 📘 Learning Goals */}
                                        <Box sx={{ mb: 3 }}>
                                            <Typography
                                                variant="subtitle2"
                                                fontWeight="bold"
                                                color="primary"
                                                gutterBottom
                                                sx={{
                                                    mb: 2,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1
                                                }}
                                            >
                                                <TrackChangesIcon fontSize="small" />
                                                Learning Goals
                                            </Typography>
                                            <Grid container spacing={2}>
                                                {section.learning_goals.map((goal, i) => (
                                                    <Grid item xs={12} sm={6} key={i}>
                                                        <Paper
                                                            elevation={1}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'flex-start',
                                                                p: 2,
                                                                borderLeft: `5px solid ${theme.palette.success.main}`,
                                                                backgroundColor: theme.palette.background.paper,
                                                                borderRadius: 2,
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateX(4px)',
                                                                    boxShadow: 2
                                                                }
                                                            }}
                                                        >
                                                            <CheckCircleOutlineIcon
                                                                fontSize="small"
                                                                sx={{ color: theme.palette.success.main, mt: "2px", mr: 1 }}
                                                            />
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    fontSize: isSmallMobile ? '0.875rem' : '1rem',
                                                                    lineHeight: 1.6
                                                                }}
                                                            >
                                                                {goal}
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Box>

                                        {/* 🧪 Activities */}
                                        <Box sx={{ mb: 3 }}>
                                            <Typography
                                                variant="subtitle2"
                                                fontWeight="bold"
                                                color="primary"
                                                gutterBottom
                                                sx={{
                                                    mb: 2,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1
                                                }}
                                            >
                                                <ScienceIcon fontSize="small" />
                                                Activities
                                            </Typography>
                                            <Grid container spacing={2}>
                                                {section.activities.map((act, i) => (
                                                    <Grid item xs={12} sm={6} key={i}>
                                                        <Paper
                                                            elevation={1}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'flex-start',
                                                                p: 2,
                                                                borderLeft: `5px solid ${theme.palette.secondary.main}`,
                                                                backgroundColor: theme.palette.background.paper,
                                                                borderRadius: 2,
                                                                transition: 'all 0.3s ease',
                                                                '&:hover': {
                                                                    transform: 'translateX(4px)',
                                                                    boxShadow: 2
                                                                }
                                                            }}
                                                        >
                                                            <CheckCircleOutlineIcon
                                                                fontSize="small"
                                                                sx={{ color: theme.palette.secondary.main, mt: "2px", mr: 1 }}
                                                            />
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    fontSize: isSmallMobile ? '0.875rem' : '1rem',
                                                                    lineHeight: 1.6
                                                                }}
                                                            >
                                                                {act}
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Box>

                                        <Divider sx={{ my: 3 }} />

                                        {/* 📘 DOK Assessment */}
                                        <Box sx={{ mb: 4 }}>
                                            <Typography
                                                variant="subtitle2"
                                                fontWeight="bold"
                                                gutterBottom
                                                color="primary"
                                                sx={{
                                                    mb: 2,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1
                                                }}
                                            >
                                                <AssessmentIcon fontSize="small" />
                                                DOK Assessment
                                            </Typography>

                                            <Paper elevation={3} sx={{ borderRadius: 3, overflow: "hidden" }}>
                                                <Box sx={{ overflowX: 'auto' }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow sx={{ backgroundColor: theme.palette.success.light }}>
                                                                <TableCell sx={{ fontWeight: "bold", color: theme.palette.success.contrastText }}>
                                                                    DOK Level
                                                                </TableCell>
                                                                <TableCell sx={{ fontWeight: "bold", color: theme.palette.success.contrastText }}>
                                                                    Description
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {section.assessment?.dok && Object.entries(section.assessment.dok).map(([level, desc], i) => (
                                                                <TableRow
                                                                    key={level}
                                                                    sx={{
                                                                        backgroundColor: i % 2 === 0 ? "background.default" : "grey.50",
                                                                    }}
                                                                >
                                                                    <TableCell>
                                                                        <strong>{level}</strong> — {dokTitles[level.toUpperCase()] || "Untitled"}
                                                                    </TableCell>
                                                                    <TableCell>{desc}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Box>
                                            </Paper>
                                        </Box>

                                        {/* 🟪 Proficiency Scale */}
                                        <Box sx={{ mb: 4 }}>
                                            <Typography
                                                variant="subtitle2"
                                                fontWeight="bold"
                                                gutterBottom
                                                color="primary"
                                                sx={{
                                                    mb: 2,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1
                                                }}
                                            >
                                                <GradeIcon fontSize="small" />
                                                Proficiency Scale
                                            </Typography>

                                            <Paper elevation={3} sx={{ borderRadius: 3, overflow: "hidden" }}>
                                                <Box sx={{ overflowX: 'auto' }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow sx={{ backgroundColor: theme.palette.secondary.light }}>
                                                                <TableCell sx={{ fontWeight: "bold", color: theme.palette.secondary.contrastText }}>
                                                                    Level
                                                                </TableCell>
                                                                <TableCell sx={{ fontWeight: "bold", color: theme.palette.secondary.contrastText }}>
                                                                    Description
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {section.assessment?.proficiency_scale && Object.entries(section.assessment.proficiency_scale).map(([level, desc], i) => (
                                                                <TableRow
                                                                    key={level}
                                                                    sx={{
                                                                        backgroundColor: i % 2 === 0 ? "background.default" : "grey.50",
                                                                    }}
                                                                >
                                                                    <TableCell sx={{ textTransform: "capitalize" }}>
                                                                        {level}
                                                                    </TableCell>
                                                                    <TableCell>{desc}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Box>
                                            </Paper>
                                        </Box>
                                    </Card>
                                </Zoom>
                            ))}

                            {/* Divider */}
                            <Divider
                                sx={{
                                    my: 4,
                                    height: 4,
                                    borderRadius: 2,
                                    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                }}
                            />

                            <Typography
                                variant={isSmallMobile ? "h6" : "h5"}
                                fontWeight="bold"
                                gutterBottom
                                sx={{
                                    textAlign: 'center',
                                    mb: 3,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 2
                                }}
                            >
                                <AssignmentIcon sx={{ fontSize: 'inherit' }} />
                                Summative Performance Task
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    pl: 2,
                                    mb: 4,
                                    fontSize: isSmallMobile ? '0.875rem' : '1rem',
                                    lineHeight: 1.6
                                }}
                            >
                                • {unitPlan.summative_task}
                            </Typography>

                            <Typography
                                variant={isSmallMobile ? "h6" : "h5"}
                                fontWeight="bold"
                                gutterBottom
                                sx={{
                                    textAlign: 'center',
                                    mb: 3,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 2
                                }}
                            >
                                <AssessmentIcon sx={{ fontSize: 'inherit' }} />
                                Assessment Rubric
                            </Typography>
                            <Paper elevation={3} sx={{ borderRadius: 3, overflow: "hidden", mb: 4 }}>
                                <Box sx={{ overflowX: 'auto' }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><strong>Skill Area</strong></TableCell>
                                                <TableCell><strong>Emerging</strong></TableCell>
                                                <TableCell><strong>Developing</strong></TableCell>
                                                <TableCell><strong>Proficient</strong></TableCell>
                                                <TableCell><strong>Extending</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {unitPlan.rubric.map((row, i) => (
                                                <TableRow key={i}>
                                                    <TableCell>{row.skill_area}</TableCell>
                                                    <TableCell>{row.emerging}</TableCell>
                                                    <TableCell>{row.developing}</TableCell>
                                                    <TableCell>{row.proficient}</TableCell>
                                                    <TableCell>{row.extending}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Paper>

                            {/* Divider */}
                            <Divider
                                sx={{
                                    my: 4,
                                    height: 4,
                                    borderRadius: 2,
                                    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                }}
                            />

                            {/* 🧍 Student Self-Assessment Section */}
                            <Paper elevation={3} sx={{
                                p: { xs: 2, sm: 3 },
                                borderRadius: 4,
                                mb: 4,
                                backgroundColor: theme.palette.background.paper,
                                border: `1px solid ${theme.palette.divider}`
                            }}>
                                <Typography
                                    variant={isSmallMobile ? "h6" : "h5"}
                                    fontWeight="bold"
                                    gutterBottom
                                    color="primary"
                                    sx={{
                                        textAlign: 'center',
                                        mb: 3,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 2
                                    }}
                                >
                                    <PersonIcon sx={{ fontSize: 'inherit' }} />
                                    Student Self-Assessment
                                </Typography>

                                {/* ✅ Checklist Items */}
                                <Box sx={{ mb: 3 }}>
                                    <Typography
                                        variant="subtitle2"
                                        fontWeight="bold"
                                        gutterBottom
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }}
                                    >
                                        <CheckCircleIcon fontSize="small" color="success" />
                                        Checklist
                                    </Typography>
                                    <List dense>
                                        {unitPlan.student_self_assessment.checklist.map((item, i) => (
                                            <ListItem key={i} sx={{ pl: 0, mb: 1 }}>
                                                <ListItemIcon sx={{ minWidth: 32 }}>
                                                    <CheckCircleIcon color="success" fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontSize: isSmallMobile ? '0.875rem' : '1rem',
                                                                lineHeight: 1.6
                                                            }}
                                                        >
                                                            {item}
                                                        </Typography>
                                                    }
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>

                                {/* 💭 Reflection Prompts */}
                                <Box sx={{ mb: 3 }}>
                                    <Typography
                                        variant="subtitle2"
                                        fontWeight="bold"
                                        gutterBottom
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }}
                                    >
                                        <PsychologyIcon fontSize="small" color="info" />
                                        Reflection Prompts
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {unitPlan.student_self_assessment.reflection_prompts.map((prompt, i) => (
                                            <Grid item xs={12} sm={6} key={i}>
                                                <Paper
                                                    variant="outlined"
                                                    sx={{
                                                        p: 2,
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        borderLeft: `4px solid ${theme.palette.info.main}`,
                                                        backgroundColor: theme.palette.grey[50],
                                                        borderRadius: 2,
                                                        transition: 'all 0.3s ease',
                                                        '&:hover': {
                                                            transform: 'translateX(4px)',
                                                            boxShadow: 2
                                                        }
                                                    }}
                                                >
                                                    <FormatQuoteIcon fontSize="small" color="info" sx={{ mt: 0.5, mr: 1 }} />
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            fontSize: isSmallMobile ? '0.875rem' : '1rem',
                                                            lineHeight: 1.6
                                                        }}
                                                    >
                                                        {prompt}
                                                    </Typography>
                                                </Paper>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>

                                {/* 🏷️ Self-Rating Options */}
                                <Box>
                                    <Typography
                                        variant="subtitle2"
                                        fontWeight="bold"
                                        gutterBottom
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }}
                                    >
                                        <GradeIcon fontSize="small" color="secondary" />
                                        Self-Rating Options
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {unitPlan.student_self_assessment.self_rating_options.map((option, i) => (
                                            <Chip
                                                key={i}
                                                label={option}
                                                color="secondary"
                                                variant="outlined"
                                                sx={{
                                                    fontSize: isSmallMobile ? '0.75rem' : '0.875rem'
                                                }}
                                            />
                                        ))}
                                    </Box>
                                </Box>
                            </Paper>
                        </Paper>
                    </Box>
                </Fade>
            )}

            {loading && (
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(255,255,255,0.8)",
                        backdropFilter: "blur(8px)",
                        zIndex: 2000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Paper
                        elevation={8}
                        sx={{
                            p: { xs: 3, sm: 4 },
                            borderRadius: 4,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            backgroundColor: "white",
                            maxWidth: 400,
                            mx: 2
                        }}
                    >
                        <FloatingGradelyLoader
                            size={60}
                            showText={true}
                            text="Generating comprehensive unit plan for your class. Please wait 1-2 minutes while your content is loading..."
                        />
                    </Paper>
                </Box>
            )}
            <AIGenerationLimitDialog
                open={showLimitDialog}
                onClose={() => setShowLimitDialog(false)}
                featureName="Unit Plan Generator"
                goToUpgrade={() => setActiveTabGlobal?.("Upgrade")}
            />
        </Container>
    );
};

export default UnitPlanGenerator;






